import React from "react";
import {message, Button, Card} from "antd"
import setTitle from "../helpers/setTitle";
import {Form, FormItem, Input, SubmitButton} from "formik-antd";
import {Formik} from "formik";
import api from "../api";
import * as Yup from "yup";
import {LockOutlined, PoweroffOutlined} from "@ant-design/icons";
import {useNavigate, useLocation} from "@/components/helpers/routerCompat";
import queryString from "query-string";
import {isMobile} from "device-detect";

export default () => {
    setTitle('Update Password');

    const location = useLocation()
    const {reset_password_token} = queryString.parse(location.search)

    const navigate = useNavigate();

    return (
        <Card title='Update Password' style={{width: isMobile() ? '100%' : 400, margin:'0 auto'}}>
            <Formik
                initialValues={{
                    password: "",
                    password_confirmation: "",
                }}
                onSubmit={async (values, actions) => {
                    try {
                        const res = await api({
                            method: 'post',
                            url: '/api/update_password',
                            data: {...values, reset_password_token}
                        });
                        // Older servers returned validation errors with HTTP 200.
                        if (res.data && Object.keys(res.data).length) {
                            message.error('Unable to update password. The link may have expired; request a new reset link.');
                            return;
                        }
                        message.success('Password updated!');
                        navigate('/login');
                    } catch (error) {
                        message.error('Unable to update password. The link may have expired; request a new reset link.');
                    } finally {
                        actions.setSubmitting(false);
                    }
                }}
                validationSchema={
                    Yup.object({
                        password: Yup.string().min(8).required('Required'),
                        password_confirmation: Yup.string()
                            .required('Required')
                            .oneOf([Yup.ref('password')], 'Password does not match'),
                    })
                }
                render={({isSubmitting}) => (
                    <Form id={'update-password-form'}>
                        <FormItem name="password" required showValidateSuccess>
                            <Input.Password
                                prefix={<LockOutlined style={{opacity:0.5}}/>}
                                name="password"
                                placeholder="Password"
                            />
                        </FormItem>

                        <FormItem name="password_confirmation" required showValidateSuccess>
                            <Input.Password
                                prefix={<LockOutlined style={{opacity:0.5}}/>}
                                name="password_confirmation"
                                placeholder="Password Confirmation"
                            />
                        </FormItem>

                        <FormItem name="submit" style={{marginBottom:0}}>
                            {isSubmitting ? (
                                <Button block type="primary" icon={<PoweroffOutlined />} loading>Updating...</Button>
                            ) : (
                                <SubmitButton block>Update</SubmitButton>
                            )}
                        </FormItem>
                    </Form>
                )}
            />
        </Card>
    );
}
